import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import axios from 'axios'

// 配置axios默认设置
console.log('设置Axios baseURL: https://bobby88888.com');
axios.defaults.baseURL = 'https://bobby88888.com';
axios.defaults.withCredentials = true; // 允许跨域请求携带凭证

const app = createApp(App)
app.use(store)
app.use(router)
app.use(Antd)
app.mount('#app')
